import { render } from "./BlockAnexos.vue?vue&type=template&id=7428ed76"
import script from "./BlockAnexos.vue?vue&type=script&lang=js"
export * from "./BlockAnexos.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockAnexos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7428ed76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7428ed76', __exports__)) {
    console.log('reload')
    api.reload('7428ed76', __exports__)
  }
  
  module.hot.accept("./BlockAnexos.vue?vue&type=template&id=7428ed76", () => {
    console.log('re-render')
    api.rerender('7428ed76', render)
  })

}


export default __exports__